import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 233;
const drawerWidthbar = 235;

export default makeStyles(theme => ({
  root: {
    display: 'flex',
  },

  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: window.isMobileView ? `calc(100% - 47px )` : `calc(100% - 74px)`,
    background: 'white',
    color: 'black',
    boxShadow: '1px 1px 1px #80808017',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidthbar}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },

  drawerPaper: {
    position: window.isIpadView ? 'fixed' : 'relative',
    whiteSpace: 'nowrap',
    background: '#0049A3',
      width: drawerWidth,
        minHeight: '100%',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: window.isIpadView ? '0 !important' : '47px !important',
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  topMobile: {
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 444,
    "& .MuiAppBar-colorPrimary": {
      backgroundColor: '#0049a3',
      borderBottomRightRadius: '25px',
      borderBottomLeftRadius: '25px',
    }
  },
  mobileLogo: {
    width: '68px',
    margin: '7px',
  },
  bottomFooter: {
    "& .MuiAppBar-positionFixed": {
      bottom: 0,
      top: 'unset',
    },
    "& .MuiAppBar-colorPrimary": {
      backgroundColor: '#0049a3',
      borderTopRightRadius: '40px',
      borderTopLeftRadius: '40px',
    },
    "& .MuiIconButton-root": {
      textAlign: 'center',
      justifyContent: 'center',
    },
    "& .MuiIconButton-label": {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      flexFlow: 'column',
      fontSize: '16px',
      textAlign: 'center',
      justifyContent: 'center',

    },
    "& img": {
      margin: 0,
    },
    "& a": {
      margin: 0,
      color: '#9db2ce',
    },
    "& p": {
      margin: 0,
      color: '#9db2ce',
    }

  },
  dashboardIco: {
    "& img": {
      filter: 'brightness(9)',
    },
    "& hover": {
        filter: 'unset !important',
    }
  },
  DropdownItems: {
    "& a": {
      display: 'flex',
      alignItems: 'inherit',
    }
  },
  fabStyle: {
    background: '#FFFFFF',
    width: window.isIphoneFive ? '65px' : '85px',
    height: window.isIphoneFive ? '65px' : '85px',
    border: '6px solid #0049A3',
    boxShadow: 'none',
    top: '-40px !important',
    right: '-8px !important',
    "& hover": {
      background: '#FFFFFF',
    }
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    padding: '0px 15px',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  rightContent: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    padding: '10px 20px',
    display: 'flex',
  },
  logoSm: {
    padding: '10px 10px',
  },

  mobileCloseIco: {
    color: 'blue',
    fontWeight: 900,
    border: '1px solid white',
    borderRadius: '50%',
    padding: '5px',
    fontSize: '30px',
    background: 'white',
    cursor:'pointer'
  },

  hasSubmenu: {
    borderTopLeftRadius: '18px',
    borderBottomLeftRadius: '18px',
    "& span": {
      color: 'white',
    },
    "& hover": {
      color: '#0049A3 !important',
      cursor: 'pointer',
      background: 'white',
      fontWeight: 500,
      textDecoration: 'none',
      borderTopLeftRadius: '18px',
      borderBottomLeftRadius: '18px',
    },
  },
  popperSub: {
    padding: '1px 0',
    "& a": {
      marginLeft: '0',
      width: '100% !important',
      padding: '10px 15px !important',
      borderTop: '1px solid #ececec',
      borderBottom: '1px solid #ececec',
      color: '#0049A3 !important',
      fontWeight: 500,
      borderRadius: '13px !important',
      display: 'flex',
      background: 'transparent !important',
      "& img": {
        filter: 'unset !important',
        maxWidth: '20px',
      },


    },
    "& .active": {
      color: '#0049A3 !important',
      background: '#DDEAF9 !important',
    },
    "& .active": {
      '& span': {
        color: '#0049A3 !important',
      },
    },
    "& :hover": {
      color: '#0049A3 !important',
      background: '#DDEAF9 !important',
    }
  },
  nested: {
    "& a": {
      marginLeft: '20px',
      width: '85% !important',
      padding: '8px 0px 8px 10px !important',
      marginBottom: '2px',
      borderTop: '1px solid #ececec',
      borderBottom: '1px solid #ececec',
      color: '#0049A3 !important',
      fontWeight: 500,
      borderRadius: '13px !important',
      background: 'transparent !important',
      "& img": {
        filter: 'unset !important',
      },


    },
    "& .active": {
      color: '#0049A3 !important',
      background: '#DDEAF9 !important',
    },
    "& :hover": {
      color: '#0049A3 !important',
      background: '#DDEAF9 !important',
    }
  },
  openHasSubmenu: {
    background: '#F6F6F6',
    borderTopLeftRadius: '18px',
    borderBottomLeftRadius: '18px',
    "& .MuiCollapse-entered": {
      "& img": {
        filter: 'unset',
        borderRadius: '0px',
      },
    },
    "& img": {
      filter: 'brightness(0)',
    },
    "& .active img": {
      filter: 'unset !important',
    },
    "& hover": {
      background: '#F6F6F6',
      "& img": {
        filter: 'invert(1)',
        background: 'unset',
        borderTopLeftRadius: 'unset',
        borderBottomLeftRadius: 'unset',
      }
    },
    "& span": {
      color: '#0049A3 !important',
    }
  },

  subMenuHead: {
    display: 'flex',
    padding: '12px 10px',
    "& span": {
      fontWeight: 500,

    }
  },

  menuList: {
      padding: '7px 0 7px 0',
      minHeight: '100vh',
    "& li": {
      padding: '0px 0px 0px 0px !important',
      display: 'block',
      borderBottom: '1px solid rgba(77, 128, 201, 0.5)'
    },
    "& img": {
      width: '27px',
    },
    "& svg": {
      width: '30px',
    },
    "& a": {
      width: '100%',
      marginTop: '0px',
      padding: '12px 10px',
      display: 'flex',
      alignItems: 'center',
      color: 'white',
    },
    "& :hover": {
      background: 'white',
      color: '#0049A3 !important',
      textDecoration: 'none',
      fontWeight: '500',
      cursor: 'pointer',
      borderTopLeftRadius: '18px',
      borderBottomLeftRadius: '18px',
      "& span": {
        color: '#0049A3 !important',
      },
      "& img": {
        // filter: 'invert(1)',
        // background: 'unset',
        // borderTopLeftRadius: 'unset',
        // borderBottomLeftRadius: 'unset',
      }
    },
    "& .active": {
      background: 'white',
      color: '#0049A3 !important',
      textDecoration: 'none',
      fontWeight: '500',
      cursor: 'pointer',
      borderTopLeftRadius: '18px',
      borderBottomLeftRadius: '18px',
      margin: '0 0 0px 0px',
      "& span": {
        color: '#0049A3 !important',
      },
      "& img": {
        // filter: 'invert(1)',
      },

    }
  },
  menuListActive: {

  },
  communicationCount: {
    "& .MuiBadge-root": {
      position: 'relative',
      right: '8px',
    },
    "& .MuiBadge-badge": {
      background: 'red',
      color: 'white !important',
      borderRadius: '50px !important',
    }
  },

  profileDropper: {
    margin: '8px 0 8px 8px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: window.isIpadView ? 'auto ' : 'initial',
    paddingRight: window.isIpadView ? '0' : 'auto',
    "& h4": {
      margin: 0,
      padding: '10px',
      color: '#0049A3',
      fontSize: '15px',
      lineHeight: '16px',
      fontFamily: 'Lato',
      textTransform: 'capitalize',
      '@media (max-width: 550px)': {
        display: 'none',
      },
    },
    "& :hover": {
      backgroundColor: 'none !important',
    },
    "& svg": {
      color: '#0049A3',
    }

  },

  MenuLabelUser: {
    margin: '0px 0px 0px 16px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    "& svg": {
      marginLeft: 'auto',
    }
  },
  MenuLabel: {
    margin: '0px 0px 0px 16px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    "& svg": {
      marginLeft: 'auto',
    }
  },
  justifyIcons:{
    justifyContent:'space-between'
  },

  menuPadding:{
    padding:'10px 0',
    cursor:'pointer'
  },
  DisableButton: {
    opacity: '0.2',
    pointerEvents: 'none',
}


}));